import { parsePhoneNumber } from "awesome-phonenumber";
import { phone as phoneNumberFormat } from "phone";

/*
 * Deprecated
 */
export const formatPhoneNumber = (phoneNumber: string) => {
  const { countryIso2 } = phoneNumberFormat(phoneNumber);
  const pn = parsePhoneNumber(phoneNumber?.replace(/^\D+/g, ""), {
    regionCode: "US",
  });
  return countryIso2 === "US" ? pn?.number?.national : phoneNumber;
};

export const formatPhoneDisplay = (phone: string): string => {
  const parsed = parsePhoneNumber(phone);
  if (!parsed?.valid) return phone;
  return parsed.regionCode === "US"
    ? (parsed.number?.national ?? phone)
    : (parsed.number?.international ?? phone);
};

/** `formatPhoneDisplay` plus ` ext. 123` when the user has an extension. */
export const formatPhoneWithExtension = (
  phone: string,
  extension: string | null | undefined,
): string => {
  // An extension means nothing without the number it belongs to.
  if (!phone) return phone;
  const formatted = formatPhoneDisplay(phone);
  const trimmedExtension = extension?.trim();
  return trimmedExtension ? `${formatted} ext. ${trimmedExtension}` : formatted;
};
